/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagecolumnprice3Inputs */

const en_ticketpagecolumnprice3 = /** @type {(inputs: Ticketpagecolumnprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

const de_ticketpagecolumnprice3 = /** @type {(inputs: Ticketpagecolumnprice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis`)
};

/**
* | output |
* | --- |
* | "Price" |
*
* @param {Ticketpagecolumnprice3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagecolumnprice3 = /** @type {((inputs?: Ticketpagecolumnprice3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagecolumnprice3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagecolumnprice3(inputs)
	return de_ticketpagecolumnprice3(inputs)
});
export { ticketpagecolumnprice3 as "ticketPageColumnPrice" }